import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 6h5m0 12h-5l-5 -12h-4","key":"svg-0"}]]

const IconOption = createReactComponent('outline', 'option', 'Option', __iconNode);

export default IconOption;